<template>
  <div class="rank-report-targeting">
    <label class="form__input">
      <span class="form__label">GEO</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.geo}"
        placeholder="Select GEO"
        :options="geo"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.clientDataModel.rank_report_targeting.geo"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.geo">{{ $parent.errorFields.geo }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Device</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        :class="{'form__field_error': $parent.errorFields.device}"
        placeholder="Device"
        :options="device"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.clientDataModel.rank_report_targeting.device"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.device">{{ $parent.errorFields.device }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Locale</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.locale}"
        placeholder="Select Locale"
        :options="locale"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.clientDataModel.rank_report_targeting.locale"
      />
      <span class="form__error-message" v-if="$parent.errorFields.locale">{{ $parent.errorFields.locale }}</span>
    </label>
<!--    <label class="form__input">-->
<!--      <span class="form__label">Note</span>-->
<!--      <p class="form__note">Leave the above rank report settings blank if you wish to default them to the client or url level settings.</p>-->
<!--      <p class="form__note">If no settings are set on the rank report, client or url level, they will default to (Phoenix, AZ / Desktop / google.com)</p>-->
<!--    </label>-->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RankReportTargeting',
  computed: {
    ...mapState('client', ['geo', 'device', 'locale'])
  }
}
</script>

<style lang="scss" scoped>
  .rank-report-targeting {}
</style>
